+function ($) { 'use strict';

	/**
	 * Inbenta Namespace
	 * @type {Object}
	 */
	if( !window.InbentaCompagnon ) window.InbentaCompagnon = {};

	window.InbentaCompagnon.baseURL = '<?=AJAX_BASE_URL?>';

	/**
	 * Assistant Definition
	 */
	var Assistant = $.extend(  {} ,
	{
		// Default options
		defaultOptions:{
			ajax: {
				url: './'
			},
			server: {},
			loaderHtml: '[iaf-loader]',
			loadingDiv: false
		},

		// configuration options,
		options: {},

		// server
		server: null,

		// last question performed
		lastQuestion: '',

		/**
		 * Constructor
		 * @param  {object} options Assistant options, will be merge with default
		 * @return {bool}         return false if something goes wrong
		 */
		initialize: function(options){
			this.options = $.extend(this.defaultOptions,options);

			if( window.InbentaCompagnon.Server ) {
				if( options && options.jsonp )
					this.server = window.InbentaCompagnon.Server.JSONP;
				else
					this.server = window.InbentaCompagnon.Server;

				this.server.initialize( this.options.server );
			}else if( options && options.jsonp )
				throw( 'JSONP api uses Server.class, please include Server.class.js' );
		},

		/**
		 * This method is prepared to work with loadJSONPInterface.
		 * Here you should try to initialize the JSONP interface, declare
		 * events.., checking that all necesarry divs, forms etc exists.
		 * If something goes wrong returning false will make that loadJSONPInterface
		 * call this function again.
		 *
		 * @param  {Object} options
		 * @return {bool} return true if your were able to load the interface
		 */
		initJSONP: function( options ){
			return true;
		},

		/**
		 * Tries to init the JSONP interface, calling initJSONP method periodically
		 * to avoid problems with form events loading later in all browsers.
		 *
     * @param  {object} options
     * @param  {int} attempts optional number of times will try to load (default 4)
		 * @param  {int} interval optional time (in milliseconds) to wait beetween attempts (default 2500)
		 * @return {void}
		 */
		loadJSONPInterface: function(options, attempts, interval)
		{
			var This = this,
        attempts = attempts || 4,
        interval = interval || 2500,
				checkTimeoutId = null,
        loaded = false;

			$(document).ready(function(){
        if (loaded) {
          return false;
        }

				if (This.initJSONP()) {
          loaded = true;
					clearTimeout(checkTimeoutId);
        }
			});

			var loadingAttempts = 0;
			function checkApiInstance()
			{
        if (loaded) {
          return false;
        }

				if (loadingAttempts >= attempts) {
					return false;
        }

				loadingAttempts++;

				if (!This.initJSONP()) {
					checkTimeoutId = setTimeout(checkApiInstance, interval);
        } else {
          loaded = true;
        }
			}

			checkTimeoutId = setTimeout(checkApiInstance, interval);
		},

		/**
		 * General method to send ajax data to the index
		 * @param  {object} data Parameters to be send
		 * @param  {function} callback Function called after sending the data
		 * @param  {String} alternative Url to perform the call
		 * @param  {object} alternative settings. Merged with default settings
		 * @return {void}
		 */
		sendData: function(data,callback,settings,bind)
		{
			settings = $.extend({},this.options.ajax, this.options.server, settings);
			settings.complete = callback || function(){},
			settings.data = data;

			if(this.server)
				this.server.send( settings, bind );
			else
				$.ajax(settings);
		},

		/**
		 * Send an ajax request to server and load the resulting html into the
		 * specified div using updateInterface function
		 * @param  {object} data data Parameters to send
		 * @param  {jQueryObject} div  Div to append the resulting html
		 * @return {void}
		 */
		loadHtml: function( data, div, settings )
		{
			settings = $.extend({},this.options.ajax, this.options.server, settings);
			settings.complete = this.updateInterface,
			settings.start = this.loadingInterface,
			settings.data = data;
			settings.callbackData = {
				'div': div
			};

			if(this.server)
				this.server.send( settings, this );
			else
				$.ajax(settings);
		},

		/**
		 * This function will be called when loading html from server.
		 * It is useful to show a loading gif or similar
		 * @param  {string} action action sended to the server
		 * @param  {object} data   extra data, like the div where the content will be loaded
		 * @return {void}
		 */
		loadingInterface: function( action, data ){
			if(action == 'search')
				// disable form to avoid multiple calls
				$('.search-form [iaf-disableonload]').attr('disabled','disabled');

			this.showLoader(action, data);
		},

		/**
		 * Shows a loading animation over the current loading div or other
		 * specified by configuration
		 * @param  {string} action
		 * @param  {object} data
		 * @return {void}
		 */
		showLoader: function(action, data)
		{
			if(this.options.loaderHtml && $(this.options.loaderHtml).length > 0)
			{
				var loadingDiv = this.options.loadingDiv ? $(this.options.loadingDiv) || data.div : data.div;
				if(this.loader)
					this.loader.remove();

				this.loader = $(this.options.loaderHtml).clone();
				$(loadingDiv).css('position', 'relative');
				$(loadingDiv).append(this.loader);
				this.loader.show();
			}
		},

		/**
		 * Hide the loading animation
		 * @param  {object} response
		 * @return {void}
		 */
		hideLoader: function(response)
		{
			if(this.options.loaderHtml && this.loader)
			{
				this.loader.hide();
				this.loader.remove();
			}
		},

		/**
		 * This function will be called each time html is loaded from the server.
		 * By default it displays the content in the provided div
		 * @param  {object} response data returned by the server. Includes extra callback data like the Div
		 *                       that shoud contain the content or the action sended to the server.
		 * @return {void}
		 */
		updateInterface: function( response )
		{
			if( !response ) return;

			if( response.action == 'search')
			{
				// enable form to avoid multiple calls
				this.searching = false;
				$('.search-form [iaf-disableonload]').removeAttr('disabled');
			}

			if(response.html)
				response.callbackData.div.html(response.html);

			this.hideLoader(response);
			$(document).trigger('inbenta.html.load');
		},

		/**
		 * Perform a search. Check if the question is valid (not empty and different)
		 * @param  {String} question User query
		 * @return {bool} True if we could perform the search
		 */
		search: function(question, ajax, div)
		{
			div = div ? $(div) : $('#inbenta-contents');

			// avoid searching twice
			if( this.searching ) return false;

			// clean question
			question = question && $.trim(question) || '';

			// avoid searching the same twice
			if(question == this.lastQuestion) return false;

			// avoid searching with empty query
			if(!question) return false;

			this.lastQuestion = question;

			this.searching = true;

			if( ajax ){
				this.loadHtml({
						action: 'search',
						q: question
					},
					div
				);
				return false;
			} else {
				return true;
      }
		},

		/**
		 * Register a click. Check if href exists to open the link
		 * @param  {String} data   click-data ($contentid;;matchtype;;logId;;external)
		 * @param  {String} href   url to open after registering the click
		 * @param  {String} target "","_self","_parent","_blank". @default ''
		 * @param {Event} e Click Event. This function also controls if we should prevent default or not.
		 * @return {void}
		 */
		click: function(data,href,target,e)
		{
			target = target || '';

			var targetFrame = undefined;
			// existsTarget is false if and only if target is an unknown frameName
			var existsTarget = true;
			if (target != '' && target.charAt(0) != '_') {
				targetFrame = this.locateFrame(window, target);
				existsTarget = (typeof targetFrame != 'undefined');
			}

			if( target != '_blank' && existsTarget && e)
				e.preventDefault();

            var dataClickKmApi = e.target.getAttribute('data-click-km-api');
            var dataRateKmApi = e.target.getAttribute('data-rate-km-api');
            if (dataClickKmApi) {
                this.sendData({
                    action: 'click-km-api',
                    idataApi: dataClickKmApi,
                    idataApiRate: dataRateKmApi
                  }, function () {
                    if( href && href != '#' ) {
						if (target == '_parent') parent.location.href = href;
						else if (target == '_top') top.location.href = href;
						// target is a known frameName
						else if (existsTarget && typeof targetFrame != 'undefined') targetFrame.location.href = href;
						// target is '_self' or empty
						else if (existsTarget && target != '_blank') document.location.href = href;
						// targets '_blank' and unknown frameName already managed before sendData
					}
                  });
            }
            else {
                this.sendData({
					action: 'click',
					idata: data
	  			}, function(){
					if( href && href != '#' ) {
						if (target == '_parent') parent.location.href = href;
						else if (target == '_top') top.location.href = href;
						// target is a known frameName
						else if (existsTarget && typeof targetFrame != 'undefined') targetFrame.location.href = href;
						// target is '_self' or empty
						else if (existsTarget && target != '_blank') document.location.href = href;
						// targets '_blank' and unknown frameName already managed before sendData
					}
			    });
            }

		},

		/**
		 * Locates a frame by its name attribute via a depth-first search from the context node downwards.
		 * @param {object} context The frame node to start the search.
		 * @param {String} frameName The name that must have the frame we are looking for.
		 * @return {object} The first frame with name=frameName to be found in a depth-first search. Undefined if none was found.
		 */
		locateFrame: function(context, frameName) {
			if (typeof context.frames[frameName] != 'undefined') return context.frames[frameName];
			else {
				for (var i=0; i<context.frames.length; i++) {
					var frame = this.locateFrame(frames[i], frameName);
					if (typeof frame != 'undefined') return frame;
				}
				return undefined;
			}
		},

		/**
		 * Perform a rate over an element
		 * @param  {int} value Rate value id
		 * @param  {int} contentId content id
		 * @param  {String} type Rate type, could be content or matching. @default "content"
		 * @param  {int} logId Search logId. @default last click logId
		 * @param  {[type]} comment Rate comment. @default ""
		 * @return {void}
		 */
		rate: function(value,type,logId,contentId,comment)
		{
			var idata = (type=='rating-content') ? logId+';;'+contentId+';;'+value+';;'+comment : logId+';;'+value+';;'+comment;
			this.sendData({
				action: type,
				idata: idata
			});
		},

		/**
		 * Display instant answers inside a popover near to the
		 * element that generate them
		 * @param  {string} html         content to be displayed
		 * @param  {string} instigator   jquery selector of the element that generate the instants
		 * @param  {object} div          jquery selector of the element that will contain the inbentaPopover
		 * @param  {String} changeEvents list of comma separated events that can change the size of the content
		 * @param  {bool} 	preserve 		 If false a different popover will be created each time
		 * @return {void}
		 */
		paintInstantAnswers: function(html, instigator, div, changeEvents, preserve)
		{
			if(!preserve && this.instantAnswersPopover)
	      this.instantAnswersPopover.inbentaPopover('destroy');

	    if(!preserve || !this.instantAnswersPopover)
	      this.instantAnswersPopover = $(html);

      this.instantAnswersPopover.inbentaPopover({
        target: $(instigator),
        container: div,
        content: $(html).children(),
        autopositionEvents: changeEvents || ''
      });
		},

		/**
		 * Display last chance faqs inside a modal/lightbox
		 *
		 * @param  {String} html           lightbox html
		 * @param  {String} centerEvents   list of comma separated events that can change the size of the content
		 * @param  {function} submitCallback modal buttons callbacks
		 * @return {void}
		 */
		paintLastChance: function(html, div, centerEvents, buttons)
		{
			if(this.instantAnswersPopover) this.instantAnswersPopover.inbentaPopover('hide');

			if(this.lastChanceModal)
				this.lastChanceModal.remove();

			this.lastChanceModal = $(html);
			$(div).append(this.lastChanceModal);
			this.lastChanceModal.inbentaModal({
				centerEvents: centerEvents,
				buttons: buttons,
				keyboard: false,
				backdrop: 'static'
			});

		},

    /**
     * Hide last chance faqs
     * @return {void}
     */
		hideLastChance: function()
		{
			if(this.lastChanceModal)
				this.lastChanceModal.inbentaModal('hide');
		},

    /**
     * Show a loader over a single div
     * @param  {object} div
     * @return {void}
     */
    showLocalLoader: function(div)
    {
      this.hideLocalLoader(div);
      var $div = $(div).first();

      if($div.length > 0 && this.options.loaderHtml && $(this.options.loaderHtml).length > 0)
      {
        $div.data('loader', $(this.options.loaderHtml).clone());

        $div.css('position', 'relative');
        $div.append($div.data('loader'));
        $div.data('loader').show();
      }
    },

    /**
     * Hide a loader over a single div
     * @param  {object} div
     * @return {void}
     */
    hideLocalLoader: function(div)
    {
      var $div = $(div).first();

      if ($div.length > 0 && $div.data('loader')) {
        $div.data('loader').remove();
      }
    }
	});
	window.InbentaCompagnon.Assistant = Assistant;

	/**
	 * JQuery utils
	 */
	$.fn.serializeJSON = function(){
		var json = {};
		this.each(function(){
			json[this.name] = $(this).val();
		});
		return json;
	};

}(window.jQuery);
